<template>
  <div
    id="createPasswordField" 
    @click="onClickCreatePasswordField"
  >
    <v-text-field
      v-model="create_password"
      required
      :type="type"
      counter="256"
      maxlength="256"
      :prepend-icon="prepend_icon"
      @input="onInputCreatePasswordField()"
      @focus="onFocusCreatePasswordField()"
      @blur="onBlurCreatePasswordField()"
    />
    <v-row
      dense
      max-width="100"
    >
      <v-col
        cols="1"
      />
      <v-col
        cols="11"
      >
        パスワード強度チェック：{{ msg }}
        <v-progress-linear
          v-model="percent"
          readonly
          :height="height"
          :color="color"
          :background-color="bgColor"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

const color_error = 'error';
const bg_color_error = 'error darken-3';
const color_ok = 'info';
const bg_color_ok = 'info darken-3';
const color_safe = 'success';
const bg_color_safe = 'success darken-3';
const percent_ng = 33;
const percent_ok = 66;
const percent_safe = 100;
const height_min = 1;
const height_nomal = 10;

const msg_ng = "10文字以上 で 数字、英大文字、英小文字を混在させてください";
const msg_user_id_ng = "ユーザーIDと同じパスワードは入力不可です。";
const msg_ok = "推測されやすい文字列が含まれています。";
const msg_safe = "強度の高いパスワードです。";

const ok_password_len = 13;

const type_pass = 'password';
const type_text = 'text';

const prepend_icon_eye_off = 'mdi-eye-off';
const prepend_icon_eye_on = 'mdi-eye';

// NG パスワード辞書
const ng_dict = [
  '!@#$%^&*',
  '!@#$%^&amp;*',
  '111111',
  '121212',
  '123123',
  '1234',
  '12345',
  '123456',
  '1234567',
  '12345678',
  '123456789',
  '123qwe',
  '1q2w3e4r',
  '1q2w3e4r5t',
  '1qaz2wsx',
  '333333',
  '555555',
  '654321',
  '666666',
  '777777',
  '7777777',
  '888888',
  '987654321',
  'aa123456',
  'abc123',
  'admin',
  'asdfghjk',
  'bailey',
  'biteme',
  'charlie',
  'donald',
  'dragon',
  'football',
  'freedom',
  'iloveyou',
  'letmein',
  'liverpool',
  'lovely',
  'michael',
  'monkey',
  'nothing',
  'passw0rd',
  'password',
  'password1',
  'princess',
  'qwerty',
  'qwerty123',
  'qwertyuiop',
  'sakura',
  'secret',
  'shadow',
  'sunshine',
  'welcome',
  'zxcvbnm',
];

export default {
  name: 'App',

  components: {
  },
  data: () => ({
    create_password : '',
    percent : percent_ng,
    height : height_min,
    color : color_error,
    bgColor : bg_color_error,
    msg : msg_ng,
    type : type_pass,
    prepend_icon : prepend_icon_eye_off,
    p_user_id : '',
  }),
  methods: {
    setNg(){
        this.percent = percent_ng;
        this.color = color_error;
        this.bgColor = bg_color_error;
        this.msg = msg_ng;
    },
    setUserIdNg(){
        this.percent = percent_ng;
        this.color = color_error;
        this.bgColor = bg_color_error;
        this.msg = msg_user_id_ng;
    },
    setOk(){
        this.percent = percent_ok;
        this.color = color_ok;
        this.bgColor = bg_color_ok;
        this.msg = msg_ok;
    },
    setSafe(){
        this.percent = percent_safe;
        this.color = color_safe;
        this.bgColor = bg_color_safe;
        this.msg = msg_safe;
    },
    onInputCreatePasswordField(){
      //別コンポーネントから呼び出したときエラーになるのを解消
      if(this.create_password === undefined){
        return;
      }
      // 長さチェック
      if(this.create_password.length < 10){
        this.setNg();
        return;
      }
      // 数値含まれないチェック
      if(this.create_password.search(/\d/g) < 0){
        this.setNg();
        return;
      }
      // 大英文字含まれないチェック
      if(this.create_password.search(/[A-Z]/g) < 0){
        this.setNg();
        return;
      }
      // 子英文字含まれないチェック
      if(this.create_password.search(/[a-z]/g) < 0){
        this.setNg();
        return;
      }
      // ユーザーIDと同じ文字列チェック
      if(this.p_user_id === this.create_password){
        this.setUserIdNg();
        return;
      }
      // OKチェック
      if(this.create_password.length <= ok_password_len){
        // Ng辞書チェック
        for(var i = 0; i < ng_dict.length; i++){
          if(this.create_password.search(ng_dict[i]) >= 0){
            this.setOk();
            return;
          }
        }
      }
      this.setSafe();
    },
    onFocusCreatePasswordField(){
      this.height = height_nomal;
    },
    onBlurCreatePasswordField(){
      this.height = height_min;
    },
    onClickCreatePasswordField(event){
      //v-icon notranslate mdi mdi-eye-off theme--light
      if(event.target && event.target.className.search(/mdi-eye-off/g) > 0){
        // パスワード文字列が見えないアイコンがおされたのでパスワードを表示
        this.prepend_icon = prepend_icon_eye_on;
        this.type = type_text;
      } else if(event.target && event.target.className.search(/mdi-eye/g) > 0){
        // パスワード文字列が見えるアイコンがおされたのでパスワードを非表示
        this.prepend_icon = prepend_icon_eye_off;
        this.type = type_pass;
      }
    },
    getPassword(){
      // NGパスワードなら返却しない
      if(this.percent === percent_ng){
        return null;
      }
      return this.create_password;
    },
    setUserId(user_id){
      this.p_user_id = user_id;
    },
  },
};
</script>

<style>
.mdi-eye {cursor:pointer;}
.mdi-eye-off {cursor:pointer;}
</style>